import { defineComponent, PropType } from 'vue'
import { Space } from '../Space'
import { MetaContent, Meta } from '../Meta'
import { Button } from '../Button'
import { MetaSpace } from '../../enums'

export default defineComponent({
  props: {
    space: {
      type: String as PropType<MetaSpace>,
      default: 'default',
    },
    options: {
      type: Array as PropType<MetaContent[]>,
      default: undefined,
    },
    loadMore: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    load(e: MouseEvent) {
      return e !== undefined
    },
  },
  setup(props, { slots, emit }) {
    return () => <Space
      class={'d-list'}
      direction={'vertical'}
      align={'unset'}
      size={0}
      block={true}
    >
      {
        props.options
          .map(
            option => {
              const p = { ...option, space: props.space }

              return <Meta
                {...p}
                v-slots={{
                  default: slots.option && (() => slots.option(p)),
                  avatar: slots.avatar && (() => slots.avatar(p)),
                  title: slots.title && (() => slots.title(p)),
                  description: slots.description && (() => slots.description(p)),
                  actions: slots.actions && (() => slots.actions(p)),
                }}
              />
            },
          )
      }
      {
        props.loadMore && <Meta space={props.space}>
          <Button
            type={'light'}
            size={'small'}
            loading={props.loading}
            iconPosition={'left'}
            block={true}
            onClick={
              e => {
                if (!props.loading) {
                  emit('load', e)
                }
              }
            }
          >
            {props.loading ? '加载中' : '加载更多'}
          </Button>
        </Meta>
      }
    </Space>
  },
})
